import React, { useRef } from "react";
import { ErrorMessage, Field, useFormik, useFormikContext } from "formik";
import _ from "lodash";

export default function InputField({
  name,
  placeholder,
  icon,
  id,
  type,
  height,
  width = "100%",
  labelTitle,
  fontSize = 14,
  isDisabled = false,
}) {
  return (
    <>
      <div
        className="p-inputgroup mt-30"
        style={{ display: "flex", flexDirection: "column" }}
      >
        {!_.isEmpty(labelTitle) && <label htmlFor={id}>{labelTitle}</label>}
        <div style={{ display: "flex", flexDirection: "row", marginTop: 5 }}>
          {icon && (
            <span className="p-inputgroup-addon">
              <i className={"pi pi-" + icon}></i>
            </span>
          )}
          <Field
            id={id}
            name={name}
            placeholder={placeholder}
            type={type}
            disabled={isDisabled}
            style={{
              width,
              border: "1px solid #f1f1f1",
              padding: "10px",
              height,
              fontSize,
              cursor: isDisabled ? "not-allowed" : "text",
            }}
          />
        </div>
        <ErrorMessage
          name={name}
          component="div"
          style={{
            marginTop: 7,
            fontSize: 14,
            fontStyle: "italic",
            color: "#ce1616",
          }}
        />
      </div>
    </>
  );
}
